import { Sparkles, Code2, Palette, Heart } from "lucide-react";
import { ACCENT, ACCENT_LIGHT } from "../constants/theme";
import Card from "../components/Card";
import SectionLabel from "../components/SectionLabel";

export default function Credit() {
  return (
    <div>
      <section style={{ background: ACCENT_LIGHT, padding: "90px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          <SectionLabel>Credits</SectionLabel>

          <div
            style={{
              width: 96,
              height: 96,
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 24px",
              boxShadow: "0 12px 35px rgba(0,0,0,0.08)",
            }}
          >
            <Sparkles size={42} color={ACCENT} />
          </div>

          <h1
            style={{
              fontSize: "clamp(34px, 5vw, 58px)",
              fontWeight: 900,
              color: "#0f172a",
              letterSpacing: "-1.5px",
              marginBottom: 16,
            }}
          >
            Rashmi Arts
          </h1>

          <p style={{ color: "#475569", fontSize: 17, lineHeight: 1.75 }}>
            This website has been thoughtfully designed and developed with creativity,
            care, and a passion for inclusive digital experiences.
          </p>
        </div>
      </section>

      <section style={{ background: "#fff", padding: "80px 24px" }}>
        <div
          style={{
            maxWidth: 1050,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: 24,
          }}
        >
          <Card>
            <Palette size={30} color={ACCENT} style={{ marginBottom: 16 }} />
            <h3 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", marginBottom: 10 }}>
              Logo By
            </h3>
            <p style={{ color: "#64748b", lineHeight: 1.7 }}>
              Rashmi Arts
            </p>
          </Card>

          <Card>
            <Code2 size={30} color={ACCENT} style={{ marginBottom: 16 }} />
            <h3 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", marginBottom: 10 }}>
              Developed By
            </h3>
            <p style={{ color: "#64748b", lineHeight: 1.7 }}>
              Ecommify
            </p>
          </Card>

          <Card>
            <Heart size={30} color={ACCENT} style={{ marginBottom: 16 }} />
            <h3 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", marginBottom: 10 }}>
              Built With
            </h3>
            <p style={{ color: "#64748b", lineHeight: 1.7 }}>
              Creativity, accessibility, and a vision beyond inclusion.
            </p>
          </Card>
        </div>
      </section>
    </div>
  );
}